import { useContext, useEffect } from 'react';
import ModeSwitcher from 'pages/stackedCalendar/header/ModeSwitcher';
import { addMonths, endOfMonth, startOfMonth } from 'date-fns';
import useAppUser from 'hooks/useAppUser';
import CalendarTodayButton from 'pages/stackedCalendar/header/CalendarTodayButton';
import { CalendarType } from 'models/Calendar';
import StandaloneCalendarContext from '../CalendarContext';
import { NavigationContainer, ButtonsWrapper } from './Navigation.styles';
import MonthsNavigation from './MonthsNavigation';

const Navigation = () => {
  const { calendarFilter, setCalendarFilter } = useContext(
    StandaloneCalendarContext,
  );
  const { isEmployee } = useAppUser();

  useEffect(() => {
    const onToday = () => {
      const today = new Date();
      const startOfToday = startOfMonth(today);
      const endOfSixMonths = endOfMonth(addMonths(today, 5));

      setCalendarFilter({
        start: startOfToday,
        end: endOfSixMonths,
      });
    };

    window.addEventListener('setTodayOnStandaloneFilters', onToday);

    return () => {
      window.removeEventListener('setTodayOnStandaloneFilters', onToday);
    };
  }, [calendarFilter]);

  return (
    <NavigationContainer>
      <MonthsNavigation />
      <ButtonsWrapper>
        <CalendarTodayButton type={CalendarType.STANDALONE_CALENDAR} />
        {isEmployee && <ModeSwitcher />}
      </ButtonsWrapper>
    </NavigationContainer>
  );
};

export default Navigation;
